export const LINK_DELETED = 'Enlace eliminado'
export const LINK_ADDED = 'Enlace agregado'
